import {
    createSession,
    deleteTrialLog,
    endSession,
    getSessionById,
    getSessions,
    pauseSession,
    refreshSession,
    resumeSession,
    saveSessionTargetOption,
    editSessionGoals,
    editSessionTimeline,
    getSessionCorrections,
    getManualSessionAppts,
    getManualSession,
    saveManualSession,
    resetManualSession,
} from './session.action';
export { sessionReducer } from './session.reducer';
export { watchSessions } from './session.saga';

export const sessionActions = {
    /** Sessions */
    createSession,
    getSessions,
    getSessionById,
    resumeSession,
    pauseSession,
    endSession,
    saveSessionTargetOption,
    deleteTrialLog,
    refreshSession,
    editSessionGoals,
    editSessionTimeline,
    getSessionCorrections,
    getManualSessionAppts,
    getManualSession,
    saveManualSession,
    resetManualSession,

    // editSession,
    // editSessionStatus,
    // deleteSession,
    /** End */
};
